var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"root"},[_c('em',{staticClass:"d-block lead text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"d-block author"},[_vm._v("—"+_vm._s(_vm.author))]),_vm._v(" "),(_vm.authorTitle)?_c('span',{staticClass:"d-block author-title"},[_vm._v(_vm._s(_vm.authorTitle))]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bd6665","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Testimonial.vue
// module id = 41
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18